import api from './APIService';

class LoginService {
	login(data) {
		return api.fetch({ method: 'post', path: '/livelaps/user/participantLogin', data });
	}
	decryptToken(data) {
		return api.fetch({ method: 'post', path: '/livelaps/user/decryptToken', data });
	}
	resetPassword(data) {
		return api.fetch({ method: 'post', path: '/livelaps/user/resetPassword', data});
	}
	forgotPassword(data, locale) {
		return api.fetch({ method: 'post', path: `/livelaps/user/forgotPassword/${locale}`, data});
	}
	logout() {
		return api.fetch({ method: 'get', path: '/logout' });
	}
	hasWaiverToSign() {
		return api.fetch({ method: 'get', path: '/participant/waivers/hasWaiverToSign'});
	}
}

export default new LoginService();
